const ROOT = '/';

export const removeRootPath = (path: string) => {
  const index = path.indexOf(ROOT);

  // Get the route after root
  return path.substring(index + ROOT.length);
};

export type URLParam = string | number;

export const buildPath = (...paths: (string | number)[]) => {
  return paths.join('/').replace(/\/+/g, '/').replace(/\/$/g, '').replace(/\/\?/g, '?');
};
